<template>
  <div class="dialog-margin delivery-time-dialog">

    <qx-select-table :data="deliveryTimeList">
      <qx-select-table-column prop="" label="交期" is-slot>
        <template #button>
          <el-button type="text" @click="add">添加</el-button>
        </template>
        <template v-slot="{scope}">
          <el-date-picker v-model="scope.row.time" type="date"
                          format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                          placeholder="请选择交付日期"/>
        </template>
      </qx-select-table-column>
      <qx-select-table-column label="主数量" prop="proportion" is-slot>
        <template v-slot="{scope}">
          <div>
            <qx-input-number v-model="scope.row.mainPlanQuantity" :controls="false"/>
          </div>
        </template>
      </qx-select-table-column>
      <el-table-column label="操作" width="50px">
        <template slot-scope="scope">
          <div class="table-operator" v-if="!scope.row.isNew">
            <i class="el-icon-third-lajitong" @click="remove(scope.$index)"/>
          </div>
        </template>
      </el-table-column>
    </qx-select-table>
    <div class="control-button padding-10">
      <el-button type="primary" @click="submit">确定</el-button>
      <el-button @click="close">关闭</el-button>
    </div>


  </div>
</template>

<script>
/**
 * @Description: 交期弹窗
 * @Author: 菩萨蛮
 * @Date: 2021/3/24 7:07 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */

export default {
  name: 'DeliveryTimeDialog',
  props: {
    deliveryTime: { type: Array, default: () => [] }
  },
  created() {
    this.deliveryTimeList = this.utils.copy(this.deliveryTime);
  },
  data() {
    return {
      deliveryTimeList: []
    };
  },
  methods: {
    add() {
      this.deliveryTimeList.push({
        time: '',
        mainPlanQuantity: ''
      });
    },
    remove(i) {
      this.deliveryTimeList.splice(i, 1);
    },
    submit() {
      const { isEmpty } = this.utils;
      const emptyCheck = this.deliveryTimeList.some(e => isEmpty(e.time) || isEmpty(e.mainPlanQuantity));
      if (emptyCheck) {
        this.$message.error('交期内容不可为空');
        return;
      }


      this.$emit('submit', this.deliveryTimeList);
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
